<template>
  <!-- We add this here so ESLint doesn't complain because the template is empty -->
  <noscript />
</template>

<script setup>
import { useHead } from '@unhead/vue'
import { usePageContext } from '../renderer/usePageContext'
import { useMainStore } from '../store'
import { getGoogleFontLinks, getCustomFontStyle } from '../utils/fontUtils'

const externalFontLinks = []
const localFonts = []

const store = useMainStore()

const processStoryblokThemeFonts = () => {
  store.theme.fontSourceFiles.forEach((font) => {
    if (font.data === undefined) {
      return
    }
    if (font.data.fontType === 'customFont' && font.data.localFonts.length) {
      localFonts.push(
        getCustomFontStyle(
          font.name,
          font.data.localFonts,
          usePageContext().nonce,
        ),
      )
    } else {
      const fontName = font.data.googleFont
        ? font.data.googleFont.family
        : font.name
      externalFontLinks.push(
        ...getGoogleFontLinks(fontName, font.googleFontVariant),
      )
    }
  })
}

if (store.theme) {
  processStoryblokThemeFonts()
}

if (localFonts.length) {
  externalFontLinks.push({
    rel: 'preconnect',
    href: 'https://s3.amazonaws.com',
    crossorigin: true,
  })
}

useHead(
  {
    link: [
      { rel: 'preconnect', href: 'https://fonts.googleapis.com' },
      {
        rel: 'preconnect',
        href: 'https://fonts.gstatic.com',
        crossorigin: true,
      },
      ...externalFontLinks,
    ],
    style: [...localFonts],
  },
  { mode: import.meta.env.VITE_IS_EDITOR ? 'client' : 'server' },
)
</script>
